<template id="Quiz">
  <v-ons-page id="QuizPage">
    <v-card class="Card_Contain d-flex align-center flex-column" style="margin-bottom: 75px">
      <div class="Card_Titulo">
        <h1>Quiz</h1>
      </div>

      <v-row class="d-flex align-baseline" style="margin-top: 60px; text-transform: none; max-height: 75px;">
        <v-text-field type="number" outlined v-model="quiz.options.countdown" style="max-width: 90px; margin-right: 15px"></v-text-field>
        Tempo para cada questão (em segundos)
      </v-row>

      <v-divider style="width: 55vw; margin: 0"></v-divider>

      <div class="quiz" v-for="(p, k) in quiz.questions" :key="k" style="width: 55vw; margin-top: 30px">
        <v-row class="d-flex align-baseline" style="max-width: 55vw;">
          <span style="width: 123px; text-align: end; color: #333333; font-size: 1.1rem;">Pergunta {{ k + 1 }}</span>
          <v-text-field outlined v-model="p.question" placeholder="Pergunta" style="margin-left: 15px"></v-text-field>
        </v-row>
        <v-row class="resposta d-flex align-baseline" v-for="(c, ck) in p.choices" :key="ck" style="max-width: 55vw;">
          <v-ons-radio :value="ck" v-model="p.correct"  /> 
          <span style=" margin-left: 10px; margin-right: 15px; width: 93px; color: #666666">Alternativa {{ ck + 1 }}</span>
          <v-text-field type="text" outlined v-model="p.choices[ck]"></v-text-field>
        </v-row>

        <v-divider style="width: 55vw; margin-top: 30px;"></v-divider>
      </div>

      <v-row class="d-flex flex-column align-center" style="width: 50vw; margin: 0; padding: 0; margin-top: 30px;">
        <v-col style="text-transform: none; max-width: 75%; margin-left: 12px;">
          <span style="color: #333333; font-size: 1.1rem;">Mensagem de agradecimento</span>
        </v-col>
        <v-col>
          <textarea
            class="textarea"
            rows="6"
            placeholder="Insira uma mensagem que será exibida para o cliente, quando ele finalizar o Quiz."
            v-model="quiz.agradecimento"
            style="margin: 20px 0"
          >
          </textarea>
        </v-col>
      </v-row>

      <v-row class="d-flex justify-center" style="margin-bottom: 30px">
        <v-col>
          <v-ons-button @click="salvarQuiz()" class="botao">Salvar Alterações</v-ons-button>
        </v-col>
        <v-col>
          <v-ons-button @click="openCardapio()" class="botao">Visualizar Cardapio</v-ons-button>
        </v-col>
      </v-row>

    </v-card>

    <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>

  </v-ons-page>
</template>

<style scoped>
#QuizPage {
  margin-left: 256px;
}
textarea {
  width: 90%;
  margin-top: 30px;
  background: #fff;
}
ons-row {
  margin-top: 20px;
}
h2 {
  color: #000;
}
input,
ons-input,
ons-select {
  background-color: #fff;
  width: 80%;
  border-radius: 5px;
  padding: 5px;
  margin-left: 15px;
  margin-right: 30px;
}
v-ons-label {
  width: 120px;
  margin-top: 12px;
  display: inline-flex;
  justify-content: flex-end;
}
.text-input {
  color: gray;
}
#QuizPage hr {
  width: 96%;
  margin: 0 auto;
  margin-top: 20px;
}
.quiz {
  text-transform: none;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}
</style>

<script>
export default {
  name: "Quiz",
  key: "Quiz",
  props: ["pageStack"],

  data() {
    return {
      idEstabelecimento: 0,
      e: { txQuiz: ""},
      quiz: {
        options: { countdown: 0 },
        questions: [{question:"", correct:0, choices:['','','']},{question:"", correct:0, choices:['','','']},{question:"", correct:0, choices:['','','']}],
        agradecimento: '',
      },
    };
  },
  mounted() {
    var e = JSON.parse(localStorage.getItem("e"));
    this.idEstabelecimento = JSON.parse(e.idEstabelecimento);
    if (e.txQuiz != undefined) {
      this.quiz = JSON.parse(e.txQuiz);
    }
  },
  methods: {
    saveLocal() {
      var e = JSON.parse(localStorage.getItem("e"))
      e.txQuiz = JSON.stringify(this.quiz);
      localStorage.setItem("e", JSON.stringify(e));
    },
    salvarQuiz() {
      fetch(this.$menu_uri + "/save-quiz", {
        method: "OPTIONS",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idEstabelecimento: this.idEstabelecimento,
          txQuiz: this.quiz,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === 1) {
            this.$ons.notification.toast("O quiz foi atualizado com sucesso.", {
              timeout: 1000,
              animation: "ascend",
            });
            this.saveLocal();
          } else {
            this.$ons.notification.toast("Nenhuma alteração foi realizada.", {
              timeout: 1000,
              animation: "ascend",
            });
          }
        })
        .then((error) => {
          if (error) {
            this.$ons.notification.toast(
              "Ocorreu um erro, por favor tente novamente.",
              { timeout: 1000, animation: "ascend" }
            );
          }
        });
    },
    openCardapio() {
      var w = window.open(
        this.$menu_base + "p/" + btoa(this.idEstabelecimento),
        "_blank"
      );
      w.focus();
    },
  },
};
</script>
